import { propPanelMixin } from '../../../../helpers';
import ExprInput from '../../../../builtin/designerComponents/ExprInput';
import ReportDimension from './ReportDimension';
import { uniqBy } from "lodash-es";
import { EventPanelIcons } from "../../../../../lib/comps/PropPanel/EventPanelNew/eventPanelIcons";
const getDefaultEidInfo = () => ({
  id: 'eid',
  value: ''
});
const __script_base__ = {
  name: 'ReportCard',
  mixins: [propPanelMixin],
  components: {
    ReportDimension,
    ExprInput
  },
  props: {
    reportKey: {
      type: String,
      required: true
    },
    reportMeta: {
      type: Object,
      default: null
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dimensions: this.value.dimensions || [],
      eidInfo: this.value.eidInfo || getDefaultEidInfo(),
      expandable: false,
      deleteIcon: EventPanelIcons.deleteIcon
    };
  },
  created() {
    if (!this.dimensions.length && this.normalDimOptions.length) {
      this.addDim();
    }
    this.$watch(() => this.dimensions, this.emitChange, {
      immediate: true,
      deep: true
    });
    this.$watch(() => this.eidInfo, this.emitChange, {
      immediate: true,
      deep: true
    });
  },
  computed: {
    // 非公共维度
    normalDimOptions() {
      var _this$designer$rootPa;
      return uniqBy((((_this$designer$rootPa = this.designer.rootPagelet) === null || _this$designer$rootPa === void 0 ? void 0 : _this$designer$rootPa.reportDimensions) || []).filter(dimension => !dimension.public).filter(dimension => dimension.id), 'id');
    },
    // 该上报用剩下的维度
    remainDimOptions() {
      const used = this.dimensions.map(({
        id
      }) => id);
      return this.normalDimOptions.filter(dimension => !used.includes(dimension.id));
    }
  },
  methods: {
    emitChange() {
      this.$emit('change', {
        dimensions: this.dimensions || [],
        eidInfo: this.eidInfo || getDefaultEidInfo()
      });
    },
    addDim() {
      this.dimensions.push({
        id: '',
        value: ''
      });
    },
    deleteDim(index) {
      this.dimensions.splice(index, 1);
    },
    // 拼接上自身的selection
    getDimOptions(dimension) {
      if (!dimension.id) return this.remainDimOptions;
      const options = this.normalDimOptions.filter(({
        id
      }) => dimension.id === id);
      return options.concat(this.remainDimOptions);
    },
    triggerExpandable() {
      this.expandable = !this.expandable;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-eventCard"
  }, [_c("div", {
    staticClass: "ucd-eventCard-header"
  }, [_c("div", {
    staticClass: "ucd-eventCard-eventName",
    attrs: {
      title: _vm.reportKey
    }
  }, [_vm._v("\n      上报: " + _vm._s(_vm.reportMeta && _vm.reportMeta.name || _vm.reportKey) + "\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "ucd-eventCard-btn-delete",
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.$emit("delete");
      }
    }
  }, [_c("img", {
    attrs: {
      src: _vm.deleteIcon
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "ucd-eventCard-content",
    staticStyle: {
      background: "#fff"
    }
  }, [_c("div", {
    staticClass: "ucd-reportCard-tip-box"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "topLeft",
      title: "维度可在工具栏 “编辑上报维度” 中修改！"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.expandable ? "编辑上报维度" : "已设置，可展开编辑") + "\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "uc-button ucd-eventCard-btn",
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.triggerExpandable.apply(null, arguments);
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-edit"
  }), _vm._v(" " + _vm._s(_vm.expandable ? "收起" : "展开") + "\n      ")])], 1), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expandable,
      expression: "expandable"
    }],
    staticClass: "ucd-reportCard-box"
  }, [_c("div", {
    staticClass: "ucd-reportCard-eidbox"
  }, [_c("div", {
    staticClass: "ucd-reportCard-item-label"
  }, [_vm._v("\n          元素ID\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "ucd-reportCard-item-value"
  }, [_c("ExprInput", {
    staticClass: "ucd-reportCard-item-expr",
    attrs: {
      placeholder: _vm.reportMeta.eidPlaceholder || "默认取组件ID作为上报标识",
      "notify-void-return": true
    },
    model: {
      value: _vm.eidInfo.value,
      callback: function ($$v) {
        _vm.$set(_vm.eidInfo, "value", $$v);
      },
      expression: "eidInfo.value"
    }
  })], 1)]), _vm._v(" "), _c("div", {
    staticClass: "ucd-reportCard-list"
  }, _vm._l(_vm.dimensions, function (dimension, index) {
    return _c("ReportDimension", {
      key: index,
      attrs: {
        dimension: dimension,
        options: _vm.getDimOptions(dimension)
      },
      on: {
        delete: function ($event) {
          return _vm.deleteDim(index);
        }
      }
    });
  }), 1), _vm._v(" "), _vm.remainDimOptions.length ? _c("button", {
    staticClass: "uc-button",
    on: {
      click: _vm.addDim
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加维度\n      ")]) : _vm._e()])])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/ReportCardList/ReportCard.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);